<template>
    <v-container class="d-flex flex-column align-center justify-center fill-height">
        <v-card class="pa-5" width="800">
            <v-card-title class="text-center text-h5">Zegar do gotowania jajek</v-card-title>
            <v-card-text class="text-center">
                <v-flex>
                    <v-btn color="primary" @click="startTimer(3)" :disabled="running">Na miękko</v-btn>
                    <v-btn color="primary" @click="startTimer(6)" :disabled="running">Na półtwardo</v-btn>
                    <v-btn color="primary" @click="startTimer(9)" :disabled="running">Na twardo</v-btn>
                </v-flex>
                <v-img src="/static/egg.gif"
                       contain
                       height="400"
                >
                </v-img>
                <div class="text-h6">Jajka gotowe za {{ timeLeft }} sekund.</div>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="error" @click="resetTimer" :disabled="!running">Reset</v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialog" max-width="400">
            <v-card class="pa-5">
                <v-card-title class="text-center text-h5">Czas minął!</v-card-title>
                <v-card-text class="text-center">
                    Jajka są gotowe! Smacznego 🥚😋
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary" @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<style scoped>
    .v-btn {
        margin: 10px;
    }

</style>

<script>
export default {
    data() {
        return {
            timeLeft: null,
            interval: null,
            dialog: false,
            running: false,
        };
    },
    methods: {
        startTimer(minutes) {
            this.timeLeft = minutes * 60;
            clearInterval(this.interval);
            this.running = true;
            this.interval = setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft--;
                } else {
                    this.running = false;
                    this.dialog = true;
                    clearInterval(this.interval);
                }
            }, 1000);
        },
        resetTimer() {
            clearTimeout(this.interval);
            this.running = false;
        },
    },
    beforeUnmount() {
        clearInterval(this.interval);
    },
};
</script>
